import { Grid, Stack } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../components/cancelButton/CancelButton";
import { ISO_DATE_FORMAT } from "../dayjs";
import type { CustomerFormState, TagsState } from "./CustomerEdit";
import CustomerEdit from "./CustomerEdit";
import { useCreateCustomer } from "./useCreateCustomer";

const defaultCustomer: () => CustomerFormState = () => ({
  name: "",
  accountManager: null,
  status: "to check",
  contactDate: null,
  meetingDate: null,
  nip: "",
  info: "",
  contacts: [],
  invoiceEmail: "",
  publicContactName: "",
  publicContactAddress: "",
  publicContactPhone: "",
  publicContactEmail: "",
  publicContactWebpage: "",
  publicContactGooglePlaceId: "",
  publicContactCity: "",
  publicContactvoivodeship: "",
  travelPayStatus: "to check",
  travelPayAccountManager: null,
});

const NewCustomerPage = () => {
  const navigate = useNavigate();
  const { createCustomer } = useCreateCustomer();
  const [tags, setTags] = useState<TagsState>({ marketSegment: [] });
  const { control, handleSubmit } = useForm<CustomerFormState>({
    defaultValues: defaultCustomer(),
  });

  const submitCustomer = async (state: CustomerFormState) => {
    const { id } = await createCustomer({
      name: state.name,
      contactDate: state.contactDate ? state.contactDate.format(ISO_DATE_FORMAT) : undefined,
      taxNo: state.nip ?? undefined,
      contacts: state.contacts.map((c) => ({
        name: c.name ? c.name : undefined,
        phone: c.phone ? c.phone : undefined,
        email: c.email ? c.email : undefined,
        loginEmail: c.loginEmail ? c.loginEmail : undefined,
        position: c.position ? c.position : undefined,
        privileges: {
          canOrderCalculation: c.privileges.canOrderCalculation,
          canCreateCalculationFromProducts: c.privileges.canCreateCalculationFromProducts,
        },
      })),
      invoiceEmail: state.invoiceEmail ? state.invoiceEmail : undefined,
      accountManagerId: state.accountManager ? state.accountManager : undefined,
      status: state.status,
      tags,
      info: state.info ? state.info : undefined,
      publicContact: {
        name: state.publicContactName ? state.publicContactName : undefined,
        address: state.publicContactAddress ? state.publicContactAddress : undefined,
        phone: state.publicContactPhone ? state.publicContactPhone : undefined,
        email: state.publicContactEmail ? state.publicContactEmail : undefined,
        webpage: state.publicContactWebpage ? state.publicContactWebpage : undefined,
        googlePlaceId: state.publicContactGooglePlaceId ? state.publicContactGooglePlaceId : undefined,
        city: state.publicContactCity ? state.publicContactCity : undefined,
        voivodeship: state.publicContactvoivodeship ? state.publicContactvoivodeship : undefined,
      },
      travelPay: {
        status: state.travelPayStatus,
        accountManagerId: state.travelPayAccountManager ?? undefined,
      },
    });
    navigate(`/customers/${id}`);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <CustomerEdit control={control} tags={tags} setTags={setTags} />
      <Grid
        size={12}
        container
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Stack direction="row" spacing={2}>
          <CancelButton onClick={() => navigate("/customers")} />
          <AsyncLoadingButton variant="outlined" onClick={handleSubmit(submitCustomer)}>
            Zapisz
          </AsyncLoadingButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewCustomerPage;
